import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { formatDate } from "../../../constants/helper";
import { AuthContext } from "../../../contexts/AuthContext";
import { Loader } from "../../../components";
import { postRequest } from "../../../constants/api";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  ButtonGroup,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditIcon from "@mui/icons-material/Edit";
import useScreenWidth from "../../../hooks/useScreenWidth";

const TampilPesertaKelompok = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch } = useContext(AuthContext);
  const { id, idPesertaKelompok } = useParams();
  const [tempIdPesertaKelompok, setTempIdPesertaKelompok] = useState("");
  const [namaPeserta, setNamaPeserta] = useState("");
  const [jenisJaminan, setJenisJaminan] = useState("");
  const [nomorJaminan, setNomorJaminan] = useState("");
  const [nilaiJaminan, setNilaiJaminan] = useState("");
  const [keterangan, setKeterangan] = useState("");
  const [isPost, setIsPost] = useState("");

  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  let today = new Date();
  let isEditableManager = user.tipeUser !== "ADMIN" && isPost === false;
  let isEditableAdmin = true;
  let isEditable = isEditableManager || isEditableAdmin;

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    getPesertaKelompokById();
  }, []);

  const getPesertaKelompokById = async () => {
    if (id) {
      const response = await postRequest(
        `/pesertaKelompoks/${idPesertaKelompok}`,
        {},
        navigate,
        dispatch
      );
      setTempIdPesertaKelompok(response.data.id);
      setNamaPeserta(response.data.peserta.namaPeserta);
      setJenisJaminan(response.data.jenisJaminan);
      setNomorJaminan(response.data.nomorJaminan);
      setNilaiJaminan(response.data.nilaiJaminan);
      setKeterangan(response.data.keterangan);
      setIsPost(response.data.isPost);
    }
  };

  const deletePesertaKelompok = async (id) => {
    try {
      setLoading(true);
      // Delete Peserta Kelompok
      await postRequest(
        `/deletePesertaKelompok/${tempIdPesertaKelompok}`,
        {},
        navigate,
        dispatch
      );
      setLoading(false);
      navigate(`/daftarKelompok/kelompok/${id}`);
    } catch (error) {
      alert(error.response.data.message);
    }
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Arisan</h3>
      <h5 style={{ fontWeight: 400 }}>Detail Peserta Kelompok</h5>
      <Button
        variant="outlined"
        color="secondary"
        onClick={() => navigate(`/daftarKelompok/kelompok/${id}`)}
        sx={{ marginLeft: 2, marginTop: 4 }}
      >
        {"< Kembali"}
      </Button>
      <Box sx={deleteButtonContainer}>
        <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{`Hapus Data`}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {`Yakin ingin menghapus data ${namaPeserta}?`}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => deletePesertaKelompok(id)}>Ok</Button>
            <Button onClick={handleClose}>Cancel</Button>
          </DialogActions>
        </Dialog>
        {isEditable && (
          <ButtonGroup variant="contained">
            <Button
              color="primary"
              startIcon={<EditIcon />}
              sx={{ textTransform: "none" }}
              onClick={() => {
                navigate(
                  `/daftarKelompok/kelompok/${id}/${idPesertaKelompok}/edit`
                );
              }}
            >
              Ubah
            </Button>
            <Button
              variant="contained"
              color="error"
              startIcon={<DeleteOutlineIcon />}
              sx={{ textTransform: "none" }}
              onClick={handleClickOpen}
            >
              Hapus
            </Button>
          </ButtonGroup>
        )}
      </Box>
      <hr />
      <Card>
        <Card.Header>Detail Peserta Kelompok</Card.Header>
        <Card.Body>
          <Form>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Nama Peserta :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={namaPeserta} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Jenis Jaminan :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={jenisJaminan} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Nomor Jaminan :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control value={nomorJaminan} disabled readOnly />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Nilai Jaminan :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      value={nilaiJaminan.toLocaleString("de-DE")}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Keterangan :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      as="textarea"
                      rows={3}
                      value={keterangan}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default TampilPesertaKelompok;

const deleteButtonContainer = {
  mt: 4,
  display: "flex",
  flexWrap: "wrap",
  justifyContent: "center",
};
